// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"613a6049","49":"3b91ef7c","354":"6473ba9e"}[chunkId] + ".js";
};